/* import __COLOCATED_TEMPLATE__ from './spam-whitelist-modal.hbs'; */
/* RESPONSIBLE TEAM: team-email */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  isOpen: boolean;
  onConfirm: (shouldWhitelist: boolean, dontAskAgain: boolean) => void;
  onClose: () => void;
}

interface Signature {
  Args: Args;
}

export default class SpamWhitelistModal extends Component<Signature> {
  @service declare intl: IntlService;

  @action handleDontAskAgain() {
    this.args.onConfirm(false, true);
    this.args.onClose();
  }

  @action handleNo() {
    this.args.onConfirm(false, false);
    this.args.onClose();
  }

  @action handleYes() {
    this.args.onConfirm(true, false);
    this.args.onClose();
  }

  @action handleClose() {
    this.args.onConfirm(false, false);
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::SpamWhitelistModal': typeof SpamWhitelistModal;
    'inbox2/spam-whitelist-modal': typeof SpamWhitelistModal;
  }
}
